// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.research-page {
  font-family: "Open Sans", sans-serif;
  background: #11224E;
  color: white;
  position: relative;
  padding-top: 2%;
}


.arrow-container {
  position: absolute;
  top: 50%;
  cursor: pointer;
}

.left-arrow-container {
  left: 5%; 
}

.right-arrow-container {
  right: -5%; 
  
}

.arrow-container img{
  width: 30%;

}
.research-title {
  font-family: "Rubik", sans-serif;
  font-weight: 800;
  display: flex;
  justify-content: center;
  font-size: 2em;
  color: #c44e00;
}

.papers-title {
  font-family: "Rubik", sans-serif;
  font-weight: 800;
  font-size: 2em;
  display: flex;
  margin-top: -2%;
  justify-content: center;
}
.circle-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin: 0 5px;
  border: 1.5px solid #c44e00;
}

.orange-circle {
  background-color: #c44e00;
}


@media (max-width: 768px) {
  .arrow-container {
    position: absolute;
    top: 23%;
    cursor: pointer;
  }
  
  .left-arrow-container {
    left: 5%; 
    width: 10%;
  }
  
  .right-arrow-container {
    left: 90%; 
    width: 10%;    
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearchPage.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,UAAU;;AAEZ;;AAEA;EACE,UAAU;;AAEZ;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap');\r\n\r\n.body {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.research-page {\r\n  font-family: \"Open Sans\", sans-serif;\r\n  background: #11224E;\r\n  color: white;\r\n  position: relative;\r\n  padding-top: 2%;\r\n}\r\n\r\n\r\n.arrow-container {\r\n  position: absolute;\r\n  top: 50%;\r\n  cursor: pointer;\r\n}\r\n\r\n.left-arrow-container {\r\n  left: 5%; \r\n}\r\n\r\n.right-arrow-container {\r\n  right: -5%; \r\n  \r\n}\r\n\r\n.arrow-container img{\r\n  width: 30%;\r\n\r\n}\r\n.research-title {\r\n  font-family: \"Rubik\", sans-serif;\r\n  font-weight: 800;\r\n  display: flex;\r\n  justify-content: center;\r\n  font-size: 2em;\r\n  color: #c44e00;\r\n}\r\n\r\n.papers-title {\r\n  font-family: \"Rubik\", sans-serif;\r\n  font-weight: 800;\r\n  font-size: 2em;\r\n  display: flex;\r\n  margin-top: -2%;\r\n  justify-content: center;\r\n}\r\n.circle-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.circle {\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 50%;\r\n  margin: 0 5px;\r\n  border: 1.5px solid #c44e00;\r\n}\r\n\r\n.orange-circle {\r\n  background-color: #c44e00;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .arrow-container {\r\n    position: absolute;\r\n    top: 23%;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .left-arrow-container {\r\n    left: 5%; \r\n    width: 10%;\r\n  }\r\n  \r\n  .right-arrow-container {\r\n    left: 90%; \r\n    width: 10%;    \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
